import { render } from "./IconFeedback.vue?vue&type=template&id=6453d9e7"
import script from "./IconFeedback.vue?vue&type=script&lang=js"
export * from "./IconFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__